// extracted by mini-css-extract-plugin
export default {"adornment":"stripe-checkout-form__adornment___Fc3As"};